// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"fb368d8f","274":"3d58315f","375":"e39b959b","397":"d680b350","420":"bb95c503","453":"7ae6cd6a","455":"9d28f1bf","841":"a726d938","977":"91768f3a"}[chunkId] + ".chunk.js";
};